import axios from './axios';

export default {
  update: (params) => axios.put(`/local_it_entite_hebergees/${params.id}`, {
    local_it_entite_hebergee: params,
  }),
};
